module.exports = __webpack_public_path__ + "static/media/logo001.d46360ef.png";